import axios from 'axios';
import DeleteModal from 'components/Common/DeleteModal';
import Spinners from 'components/Common/Spinner';
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { Form, Label, Input, Button, FormGroup } from 'reactstrap'

const SelectDesigns = () => {
    const navigate = useNavigate();
    const [selectedDesignId, setSelectedDesignId] = useState("");
    const [designOptions, setDesignOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    const [deleteModal, setDeleteModal] = useState({
        isShow: false,
        "id": "",
        "user_id": ""
    })

    const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
    }

    const handleNavigate = (id) => {
        navigate(`/Saved-Design/${id}`)
    }


    const ShowDeleteModal = (design) => {
        setDeleteModal({
            "isShow": true,
            "id": design.id,
            "user_id": design.user_id
        })
    }

    const closeDeleteModal = () => {
        setDeleteModal({
            "isShow": false,
            "id": "",
            "user_id": ""
        })
    }

    const handleDeleteDesign = async () => {
        setLoading(true)
        try {
            let apiToken = JSON.parse(localStorage.getItem("authUser"))
            const headers = {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: apiToken,
                Accept: "application/json",
                "Cache-Control": "no-cache",
            }

            const response = await axios.post(`${apiBaseUrl}/Delete-design`, {
                id: deleteModal.id,
                user_id: deleteModal.user_id
            }, {
                headers,
            })

            if (response.status === 200) {
                toast.success("Deleted Successfully!");
                closeDeleteModal();
                setLoading(false)

            } else {
                toast.error("Something Unexpected error occured, please try again");
                closeDeleteModal();
                setLoading(false)
            }
        } catch (error) {
            toast.error("Something Unexpected error occured, please try again");
            closeDeleteModal();
            setLoading(false)
        }
    }
    useEffect(() => {
        const getDesign = async () => {
            setLoading(true)
            try {
                const response = await axios({
                    method: "GET",
                    url: `${apiBaseUrl}/get-desigins`,
                    params: {
                        user_id: localStorage.getItem("id"),
                    },
                    headers: headers,
                })

                if (response.status === 200) {
                    setDesignOptions(response.data.data)
                    setLoading(false)

                } else {
                    console.log("Something went wrong")
                    setLoading(false)
                }
            } catch (error) {
                console.error("Error fetching designs:", error)
                setLoading(false)
            }
        }

        getDesign()
    }, [])
    return (
        <div className='page-content'>
            <div className='mt-1'>
                <h2>Marketing tools Designs</h2>
            </div>

            <div className='mt-3 mx-auto'>

                {
                    loading ? <Spinners /> : (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Design Name</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {designOptions.map((design, index) => (

                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td> {design.design_name}</td>
                                        <td className='d-flex justify-around'>
                                            <div>
                                                <Button className="btn btn-sm btn-soft-primary" size='sm' onClick={() => handleNavigate(design.id)}><i className="mdi mdi-eye-outline" /></Button>
                                            </div>
                                            <div>
                                                <Button
                                                    className="btn btn-sm btn-soft-danger ms-2"
                                                    size='sm'
                                                    onClick={() => ShowDeleteModal(design)}><i className="mdi mdi-delete-outline" /></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}


                            </tbody>
                        </table>
                    )
                }
            </div>

            <DeleteModal
                show={deleteModal.isShow}
                onDeleteClick={handleDeleteDesign}
                onCloseClick={closeDeleteModal}
                displayMsg={"Are you sure? Do you want to delete this design"}
            />
        </div>
    )
}

export default SelectDesigns